import React from "react";
import inkindLogo from "../../../../assets/images/enterprise/inkind/icons/logo-new.png";
import closeIcon from "../../../../assets/images/map_v2/close-ic-black.svg";
import expand from "../../../../assets/images/map_v2/expand_more_black.svg";
import { motion } from "framer-motion";
import { getAppUrl } from "./BrandDetails";
import { Location } from "../types/mapData";

type Props = {
  infoOpenMobile: boolean;
  curLoc: Location | null;
  curBrand: number;
  popUpOpen: boolean;
  setPopUpOpen: (open: boolean) => void;
  maxBonus: number;
  purchaseModeTiers: boolean;
  totalLocationCount: number;
};

const PassPopup = ({
  infoOpenMobile,
  curLoc,
  curBrand,
  popUpOpen,
  setPopUpOpen,
  maxBonus,
  purchaseModeTiers,
  totalLocationCount,
}: Props) => {
  return (
    <motion.div
      className={
        !infoOpenMobile && !curLoc && !curBrand
          ? "pass-popup"
          : "pass-popup hide-on-small"
      }
      id="pass-popup"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="pass-header">
        <img src={inkindLogo} alt="inKind Pass" className="pass-logo" />
        <img
          src={closeIcon}
          alt="close button"
          className="close-logo"
          id="popup-close"
          onClick={() => setPopUpOpen(!popUpOpen)}
        />
      </div>
      {!!purchaseModeTiers ? (
        <div className="pass-container">
          <div className="pass-headline">Get a bonus at every location!</div>
          <div>
            Purchase one account, redeemable at&nbsp;
            <span className="text-bold">hundreds</span> of inKind partner
            venues.
          </div>
          <a href={getAppUrl()} target="blank" className="download-button">
            Get up to ${maxBonus} on us!
            <img src={expand} alt="inKind Pass" className="arrow-logo" />
          </a>
        </div>
      ) : (
        <div className="pass-container">
          <div className="pass-headline">Earn up to 20% back</div>
          <div>
            Get rewarded when you dine at any of the {totalLocationCount}+
            locations on inKind
          </div>
          <a href={getAppUrl()} target="blank" className="download-button">
            Download Now
            <img src={expand} alt="inKind Pass" className="arrow-logo" />
          </a>
        </div>
      )}
    </motion.div>
  );
};

export default PassPopup;
